<template>
  <component
    :is="currentComponent"
    class="btn"
    :class="[`btn-${variant}`, { 'btn-fluid': fluid }]"
    v-bind="attributes"
    :disabled="disabled"
  >
    <slot></slot>
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Variant from '@/types/interface/Button.interface';

interface RouterButtonProps {
  to?: string;
  disabled?: boolean;
  variant?: Variant;
  fluid?: boolean;
}

const props = withDefaults(defineProps<RouterButtonProps>(), {
  variant: 'primary',
  fluid: false,
});

const currentComponent = computed(() => {
  if (props.to) {
    return 'router-link';
  } else {
    return 'button';
  }
});

const attributes = computed(() => {
  if (currentComponent.value === 'router-link') {
    return {
      to: props.to,
    };
  } else {
    return {};
  }
});
</script>
